(ns renolit-roofing-service.layout.display-item
  (:require [renolit-roofing-service.localization :refer [t]]))

(defmulti display-item-component :type)

(defn get-value
  [{:keys [value state path]}]
  (cond
    (some? value)
    value

    (and state (some? (get-in @state path)))
    (get-in @state path)

    :else
    (t [:common/no-data])))

(defn main
  [{:keys [label css-class-prefix class label-transl-kw label-count style] :as opts}]
  [:div.display-item
   {:class (cond-> []
             (coll? class)
             (into class)

             (string? class)
             (conj class)

             css-class-prefix
             (conj css-class-prefix)

             style
             (conj (str "display-item--style-" (name style))))}
   (when (or label-transl-kw label)
     [:label.display-item__label
      (cond-> {}
        css-class-prefix
        (assoc :class (str css-class-prefix "__label")))
      (if label-count
        (t [label-transl-kw] [(count (get-value opts))])
        (or (t [label-transl-kw]) label))])
   [display-item-component opts]])
